import React from "react";
import { Validator, Switch } from "devextreme-react";

class SwitchField extends React.PureComponent {
  render() {
    const {
      label,
      switchedOffText,
      switchedOnText,
      defaultValue,
      disabled,
      value,
      onChange,
      id,
      optional,
      validation,
      visible,
      ...rest
    } = this.props;
    return (
      <div className="field-newDenuncia" style={{ marginLeft: optional ? 20 : 0 }}>
        <h3><p>{visible && label}</p></h3>
        <Switch
          switchedOffText={switchedOffText}
          switchedOnText={switchedOnText}
          disabled={disabled}
          defaultValue={defaultValue}
          value={value}
          visible={visible}
          onValueChanged={onChange}
          id={id}
          {...rest}
        >
          {(validation !== false) ?
            <Validator
              validationRules={[{
                type: "custom",
                validationCallback: (e) => e.value != null,
                message: "Este campo es requerido",
              }]}
            />
            : ""
          }
        </Switch>
      </div>
    );
  }
}

export default SwitchField;
